import React, { ReactElement, useEffect, useState } from 'react';
import PageHeader from '../../../shared/components/pageHeader/PageHeader';
import { GUTTOR_SPACE } from '../../../shared/constants/commonConstants';
import { Card, Row, Skeleton } from 'antd';
import { ReactComponent as Refresh } from '../../../assets/images/svg/Refresh.svg';
import DetailsCard from './DetailsCard';
import DiagnosisCard from './Diagnosis';
import { base64UrlDecode, centeredNotification } from '../../../utils/utility';
import { useDispatch } from 'react-redux';
import { getConcentDetail } from '../../../store/actions/abdmHiuAction';
import { prepareConsentDetail } from '../abdmUtils';
import { useHistory } from 'react-router-dom';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';

const ConcentDetail = ({ match }: any): ReactElement => {
  const { params: { data } } = match;
  const dispatch = useDispatch();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [detail, setDetail] = useState<any>([]);
  const isVersioningPostAPIEnabled = ApplicationDetail?.instance?.getIsVersioningPostAPIEnabled();

  useEffect((): any => {
    fetchDetail();
  }, [data]);

  const fetchDetail = (): any => {
    try {
      const selectedRecord = JSON.parse(base64UrlDecode(data));
      setIsLoading(true);
      const request = {
        requestId: selectedRecord?.requestId,
      };
      dispatch(getConcentDetail(isVersioningPostAPIEnabled ? request : selectedRecord?.requestId, (res: any[]): any => {
        onSuccessFetch(res, selectedRecord);
      }));
    } catch (e) {
      centeredNotification('Looks like some data is missing, Please try again.');
      history.goBack();
    }
  };

  const onSuccessFetch = (consentDetail: any[], selectedRecord: any): any => {
    const finalDetail = prepareConsentDetail(consentDetail, selectedRecord);
    setDetail(finalDetail);
    setIsLoading(false);
  };

  const Loader = (): any => (
    <Card className="loader">
      <Skeleton active={true} />
    </Card>
  );

  return (
    <React.Fragment>
      <PageHeader
        pageTitle="Health Data"
        backUrl="/abdm/concent-list"
        rightComponent={(): any => (<Row gutter={GUTTOR_SPACE} justify="end" className="rightComponent mr-10">
          <span className="m-xs">
            <Refresh onClick={fetchDetail} />
          </span>
        </Row>)}
      />
      {isLoading ? <Loader /> : <DetailsCard detail={detail} />}
      {isLoading ? <div><Loader /><Loader /></div> : <DiagnosisCard detail={detail} />}
    </React.Fragment>);
};

export default ConcentDetail;
